<div class="dasboard-width"  (window:resize)="onResize($event)">
    <div class="row header mar-lft-rgt-0">
      <div class="col-md-6">Report Dashboard - Prescriptive Model</div>
    </div>
    <div class="content mr-top-5 mar-lft-rgt-0">
      <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
      <div class="row content mr-top-5 mar-lft-rgt-0">
        <div class="col-md-3">
            <div class="form-group">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedReportType"
                        (change)="onReportTypeChange($event.target.selectedIndex)">
                  <option *ngFor="let reportType of reportTypeArray" [value]="reportType.type">{{reportType.view}}</option>
                </select>
            </div>
        </div>
        <div *ngIf="viewTicketType" class="col-md-3">
            <div class="form-group">
                <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="selectedTicketType"
                        (change)="onTicketTypeChange($event.target.selectedIndex)">
                  <option *ngFor="let ticketType of ticketTypeArray" [value]="ticketType.id">{{ticketType.name}}</option>
                </select>
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13" [(ngModel)]="lastXmonth"
             placeholder="Last x months">
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13" [(ngModel)]="maxSla"
             placeholder="Max SLA compliance %">
            </div>
        </div>
        
        <div class="col-md-2">
            <button  type="button" class="btn btn-success radius-0" (click)="generateDashboardReport()">Submit</button>
        </div>
      </div>
      <div [hidden]="!viewReport" class="row mar-lft-rgt-0">
          <div class="col-12">
                  <button  type="button" class="btn btn-success font-13 radius-0 float-right" (click)="exportAsPDF()">Export to PDF</button>
          </div>
      </div>
      
      <div class="row content mr-top-5 mar-lft-rgt-0" #reportBody>
        <div class="col-lg-12" style="padding: 1%">
          <div [hidden]="!viewReport" style="text-align: center; border: 1px solid; min-width: 500px;">
              <div style="text-align: center;">{{reportTypeTitle}} - {{reportFilterTitle}} Heat Map</div>
              <div #heatMap id="heat-map"></div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
  